/**
 * Formats a number to a string with 2 decimal places and local formatting (commas for thousands).
 * @param {number|string} val - The value to format.
 * @returns {string}
 */
export const formatNumber = (val) => {
  return Number(val || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}
